module.exports = __webpack_public_path__ + "img/tigre-home-first-min.aa609c89.jpg";